import React from 'react';
import ContainerItemView from 'go/components/modules/requestDetails/v3/items/shared/ContainerItemView';
export const ContainerItem = (props) => <ContainerItemView {...props} />;
export default ContainerItem;
